import { render, staticRenderFns } from "./TextCard.vue?vue&type=template&id=d5979e6e&scoped=true"
import script from "./TextCard.vue?vue&type=script&lang=js"
export * from "./TextCard.vue?vue&type=script&lang=js"
import style0 from "./TextCard.vue?vue&type=style&index=0&id=d5979e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5979e6e",
  null
  
)

export default component.exports